export default "__VITE_ASSET__BBEMgutH__"